import Markdown from "react-markdown";
import { Badge } from "../Badge";
import cx from "classnames";
import { HoverGallery, type Image } from "./HoverGallery";

export function ProjectCard({
  images,
  hackathon,
  title,
  description,
  repoLink,
  learnMoreLink,
  techStack,
}: {
  images?: Image[];
  hackathon?: boolean;
  title: string;
  description: string;
  repoLink?: string;
  learnMoreLink?: string;
  techStack?: string[];
}) {
  return (
    <div className='border border-gray-300 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 bg-base-200 flex flex-col'>
      {images && <HoverGallery images={images} />}
      <div className='p-6 flex flex-col justify-between grow gap-6'>
        <div>
          <h5 className='text-lg md:text-xl font-semibold mb-2'>{title}</h5>
          {repoLink && <Badge text='Open Source' className='mb-4 text-primary' />}
          {hackathon && <Badge text='Hackathon' className={cx("mb-4 text-secondary", { "ml-2": repoLink })} />}
          <div className='text-base-content/80 text-sm md:text-base whitespace-pre-wrap'>
            <Markdown>{description}</Markdown>
          </div>
        </div>

        <div>
          <div className='flex gap-8 justify-between'>
            {/* Github Repo Button */}
            {repoLink && (
              <a className='btn btn-sm lg:btn-md rounded-lg' href={repoLink} target='_blank'>
                <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className='size-4'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25'
                  />
                </svg>
                Github
              </a>
            )}

            {/* Learn More Button */}
            {learnMoreLink && (
              <a className='btn btn-outline btn-neutral btn-sm lg:btn-md rounded-lg' href={learnMoreLink} target='_blank'>
                Learn More
              </a>
            )}
          </div>

          <div>
            {techStack && (
              <div className='mt-6 flex flex-wrap gap-2'>
                {techStack.map((tech, index) => (
                  <Badge key={index} text={tech} className='text-base-content/70' />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
